import axios from "axios";
import router from "../router/index"
import store from '../store'
import { Toast } from 'vant';
import { getQueryString } from "./tool";
import codeStatus from './codeStatus'
import { Message, Loading } from 'element-ui'
import { host } from './index'


let loading;
// 是否显示重新登录
export let isRelogin = { show: false };

function startLoading() { //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.08)',
  })
}
import { getToken, removeToken } from './auth'

function endLoading() { //使用Element loading-close 方法
  loading.close();
}

export function post(url, params = {}, set = {}, urlParams = "") {
  let headers = {
    'windowCode': localStorage.getItem('code'),
    // 'Content-Type': 'multipart/form-data'
  }
  const config = {
    headers
  }
  const api_token = getToken();
  if (api_token) {
    params.api_token = api_token
  }
  if (urlParams) {
    url = url + urlParams
  }
  // params.v = new Date().getTime()
  // console.log("请求参数", params);
  return new Promise((resolve, reject) => {
    if (set.loading) {
      startLoading();
    }
    axios.post(host + url, params, config).then(res => {
      if (set.loading) {
        setTimeout(() => {
          endLoading();
        }, 200);
      }
      resolve(res.data);
    }).catch(err => {
      if (set.loading) {
        setTimeout(() => {
          endLoading();
        }, 200);
      }
      catchFn(err)
      reject(err.data)
    })
  });
}
/** 
 * get方法，对应get请求
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数]  
 */
export function get(url, params = {}, set = {}, urlParams = "") {
  let headers = {
    'windowCode': localStorage.getItem('code'),
  }
  const api_token = getToken();

  if (api_token) {
    params.api_token = api_token
  }
  if (urlParams) {
    url = url + '/' + urlParams
  }
  params.v = new Date().getTime()
  // console.log("请求参数", params);
  return new Promise((resolve, reject) => {
    if (set.loading) {
      startLoading();
    }
    axios.get(host + url, {
      headers: headers,
      params: params
    })
      .then(res => {
        if (set.loading) {
          setTimeout(() => {
            endLoading();
          }, 200);
        }
        resolve(res.data);
      })
      .catch(err => {
        catchFn(err)
        if (set.loading) {
          setTimeout(() => {
            endLoading();
          }, 200);
        }
        reject(err.data)
      })
  });
}

function catchFn(error) {
  console.log(error, '66')
  let { message } = error;
  if (message == "Network Error") {
    message = "后端接口连接异常";
  } else if (message.includes("timeout")) {
    message = "系统接口请求超时";
  } else if (message.includes("Request failed with status code")) {
    // message = "系统接口" + message.substr(message.length - 3) + "异常";
    let code = error.response && error.response.status ? error.response.status : null;
    console.log(code, '---');

    if (code) {
      if (code == 422 || code == 406) {
        message = error.response.data.message
      } else if (code == 500) {
        message = (error.response.data.message ? error.response.data.message : '系统错误')
        let errorCode = error.response.data.code;
        if (errorCode == 202) {
          if (!isRelogin.show) {
            isRelogin.show = true;
            Message({ message: '登录状态已过期，请重新登录', type: 'error', duration: 5 * 1000 })
            removeToken()
            router.replace('/login?code='+localStorage.getItem('code'))
          }
          return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
        }
      }
    }
  }
  Message({ message: message, type: 'error', duration: 5 * 1000 })
  return Promise.reject(error)
}